import en from './en'
import cn from './cn'
import yn from './yn'
// import ko from './ko';
export default {
  en: en,
  cn: cn,
  yn: yn,
  // ko: ko
}
